import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'view-status',
    templateUrl: 'viewstatus.component.html',
    styleUrls: ['viewstatus.less']
})
export class ViewStatusComponent {
    disabledValue: boolean = false;
    maintenanceValue: boolean = false;
    viewArchiveValue: boolean = false;
    archiveValue: boolean = false;
    bulkValue: boolean = false;
    emeaViewStatus: any;
    naViewStatus: any;
    saViewStatus: any;
    cnViewStatus: any;
    roaViewStatus: any;

    toggleBulkViewStatus: boolean = true;
    toggleBulkViewStatusNa: boolean = true;
    toggleBulkViewStatusSa: boolean = true;
    toggleBulkViewStatusCn: boolean = true;
    toggleBulkViewStatusRoa: boolean = true;

    @Output() emeaChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() naChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() saChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() cnChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() roaChange: EventEmitter<any> = new EventEmitter<any>();

    @Output() toggleViewStatusChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() toggleViewStatusNaChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() toggleViewStatusSaChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() toggleViewStatusCnChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() toggleViewStatusRoaChange: EventEmitter<any> = new EventEmitter<any>();

    @Input() get disabled()   { return this.disabledValue; }
    @Input() get maintenance()   { return this.maintenanceValue; }
    @Input() get viewArchive()   { return this.viewArchiveValue; }
    @Input() get archive()   { return this.archiveValue; }
    @Input() get bulk()   { return this.bulkValue; }

    @Input() get toggleViewStatus()   { return this.toggleBulkViewStatus; }
    @Input() get toggleViewStatusNa()   { return this.toggleBulkViewStatusNa; }
    @Input() get toggleViewStatusSa()   { return this.toggleBulkViewStatusSa; }
    @Input() get toggleViewStatusCn()   { return this.toggleBulkViewStatusCn; }
    @Input() get toggleViewStatusRoa()   { return this.toggleBulkViewStatusRoa; }

    @Input() get emea()   { return this.emeaViewStatus; }
    @Input() get na()     { return this.naViewStatus; }
    @Input() get sa()     { return this.saViewStatus; }
    @Input() get cn()     { return this.cnViewStatus; }
    @Input() get roa()    { return this.roaViewStatus; }

    set bulk(val) {
        this.bulkValue = val;

        if (this.bulkValue) {
            this.toggleBulkViewStatus = false;
            this.toggleBulkViewStatusNa = false;
            this.toggleBulkViewStatusSa = false;
            this.toggleBulkViewStatusCn = false;
            this.toggleBulkViewStatusRoa = false;
        }
    }

    set toggleViewStatus(val) {
        this.toggleBulkViewStatus = val;
    }

    set toggleViewStatusNa(val) {
        this.toggleBulkViewStatusNa = val;
    }

    set toggleViewStatusSa(val) {
        this.toggleBulkViewStatusSa = val;
    }

    set toggleViewStatusCn(val) {
        this.toggleBulkViewStatusCn = val;
    }

    set toggleViewStatusRoa(val) {
        this.toggleBulkViewStatusRoa = val;
    }

    set disabled(val) {
        this.disabledValue = val;
    }

    set maintenance(val) {
        this.maintenanceValue = val;
    }

    set viewArchive(val) {
        this.viewArchiveValue = val;
    }

    set archive(val) {
        this.archiveValue = val;
    }

    set emea(val) {
        this.emeaViewStatus = val;
    }

    set na(val) {
        this.naViewStatus = val;
    }

    set sa(val) {
        this.saViewStatus = val;
    }

    set cn(val) {
        this.cnViewStatus = val;
    }

    set roa(val) {
        this.roaViewStatus = val;
    }

    emeaSelect(val) {
        this.emeaViewStatus = val;
        this.emeaChange.emit(this.emeaViewStatus);
    }

    naSelect(val) {
        this.naViewStatus = val;
        this.naChange.emit(this.naViewStatus);
    }

    saSelect(val) {
        this.saViewStatus = val;
        this.saChange.emit(this.saViewStatus);
    }

    cnSelect(val) {
        this.cnViewStatus = val;
        this.cnChange.emit(this.cnViewStatus);
    }

    roaSelect(val) {
        this.roaViewStatus = val;
        this.roaChange.emit(this.roaViewStatus);
    }

    toggleViewStatusAction() {
        this.toggleBulkViewStatus = !this.toggleBulkViewStatus;
        this.toggleViewStatusChange.emit(this.toggleBulkViewStatus);
    }

    toggleViewStatusActionNa() {
        this.toggleBulkViewStatusNa = !this.toggleBulkViewStatusNa;
        this.toggleViewStatusNaChange.emit(this.toggleBulkViewStatusNa);
    }

    toggleViewStatusActionSa() {
        this.toggleBulkViewStatusSa = !this.toggleBulkViewStatusSa;
        this.toggleViewStatusSaChange.emit(this.toggleBulkViewStatusSa);
    }

    toggleViewStatusActionCn() {
        this.toggleBulkViewStatusCn = !this.toggleBulkViewStatusCn;
        this.toggleViewStatusCnChange.emit(this.toggleBulkViewStatusCn);
    }

    toggleViewStatusActionRoa() {
        this.toggleBulkViewStatusRoa = !this.toggleBulkViewStatusRoa;
        this.toggleViewStatusRoaChange.emit(this.toggleBulkViewStatusRoa);
    }
}



// WEBPACK FOOTER //
// ./src/app/_component/viewstatus/viewstatus.component.ts